import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {
  constructor() {}

  wallHeight = 304.8;
  wallDepth = 20.32;
  wallWidth = 15;
  UNDO_STACK_LIMIT = 5;
  deckHeight = 20.32; // 8 inches,
  minimalSpaceForStairsOnSIde = 0; // 9"
  windowHeightAboveFloor = 65;
  windowAwningHeightAboveFloor = 217;
  supportPostSize = {
    width: 15.24,
    length: 15.24,
    height: 30.48
  };
  inermediateStepSize = {
    height: 27.94,
    length: 34.867,
    width: 106.68
  };
  minimalStairsWidth = 60.69;
  wallUnitLength = {
    FT: true,
    M: false
  };
  HighlightState = {
    DEFAULT: 0x000000,
    SELECTED: 0xffff00,
    ERROR: 0xff0000
  };
  SizeUnit = {
    CM: 0,
    FT: 1,
    INCH: 2,
    FT_INCH: 3,
    M: 4,
    CM_METER: 5
  };
  // tierHeightShift
  // adjusted na glaz
  // to do
  // make normal calculations
  tierTypeSettingsMap = {
    tier1StepUp: {
      spriteUrl: '../../assets/images/sprites/tier_1_up.png',
      tierHeightShift: 20.32,
      distanceToTier: 0,
      errorMessage: ''
    },
    tier2StepUp: {
      spriteUrl: '../../assets/images/sprites/tier_2_up.png',
      tierHeightShift: 17 + 20.32,
      distanceToTier: 22.86,
      errorMessage: ''
    },
    tier3StepUp: {
      spriteUrl: '../../assets/images/sprites/tier_3_up.png',
      tierHeightShift: 20.5 + 14 + 20.32,
      distanceToTier: 45.72,
      errorMessage: ''
    },
    tier1StepDown: {
      spriteUrl: '../../assets/images/sprites/tier_1_down.png',
      tierHeightShift: -20.32,
      distanceToTier: 0,
      errorMessage: '1 step down tier can only be added if deck height is greater than 1\' 4"'
    },
    tier2StepDown: {
      spriteUrl: '../../assets/images/sprites/tier_2_down.png',
      tierHeightShift: -17 - 20.32,
      distanceToTier: 22.86,
      errorMessage: '2 step down tier can only be added if deck height is greater than 1\' 11"'
    },
    tier3StepDown: {
      spriteUrl: '../../assets/images/sprites/tier_3_down.png',
      tierHeightShift: -55,
      distanceToTier: 45.72,
      errorMessage: '3 step down tier can only be added if deck height is greater than 2\' 6"'
    }
  };

  defaultColors = {
    DesignRail: {
      Post: 'Black',
      'Top Rail': 'Black',
      'Bottom Rail': 'Black',
      Picket: 'Black',
      'Top Cap': 'Redwood',
      'Laser Cut Agama': 'Black',
      'Laser Cut Bound': 'Black',
      'Laser Cut Cubist': 'Black',
      'Laser Cut Pisces': 'Black',
      'Laser Cut Rhythm': 'Black',
      'Laser Cut Seagrass': 'Black',
      'Laser Cut Sverra': 'Black',
      'Laser Cut Trillium': 'Black',
      'Laser Cut Pulse': 'Black',
      'Laser Cut Kelly 1': 'Black',
      'Laser Cut Kelly 2': 'Black',
      'Laser Cut Kelly 3': 'Black',
      'Laser Cut Kelly 4': 'Black',
      'Laser Cut Kelly 5': 'Black',
      'Laser Cut Kelly 6': 'Black',
      'Laser Cut Kelly 7': 'Black',
      'Laser Cut Kelly 8': 'Black',
      'Laser Cut Kelly 9': 'Black'
    },
    Wood: {
      Post: 'Redwood',
      'Top Rail': 'Redwood',
      'Bottom Rail': 'Redwood',
      Picket: 'Silver'
    },
    Composite: {
      Post: 'Matte Black',
      'Top Rail': 'Matte Black',
      'Bottom Rail': 'Matte Black',
      Picket: 'Silver'
    },
    'Steel flat bar': {
      Post: 'Black',
      'Top Rail': 'Black',
      'Bottom Rail': 'Black'
    },
    'Steel round tubular': {
      Post: 'Black',
      'Top Rail': 'Black',
      'Bottom Rail': 'Black'
    },
    // Modern kit: Series 250 top rail, posts and intermediate pickets; the
    // slat infill rides the Horizontal Cable products and is not colorable
    Modern: {
      Post: 'Black',
      'Top Rail': 'Black',
      Picket: 'Black'
    },
    // DockRail Series 200: 3 metal colors, cable infill is not colorable
    DockRail: {
      Post: 'Black',
      'Top Rail': 'Black'
    }
  };

  modelsChildrenNamesForColorChange = {
    Post: ['Post', 'Cap'],
    'Top Rail': ['Handrail'],
    'Bottom Rail': ['Bottomrail'],
    Picket: ['Pickets', 'IPicket'],
    'Stair Handrail': [
      'Handrail',
      'CenterLeft',
      'Bracket',
      'TopLeft',
      'TopRight_TopLeft.003',
      'BottomLeft',
      'BottomRight'
    ],
    'Top Cap': ['TopCap'],
    'Laser Cut Agama': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Bound': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Cubist': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Pisces': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Rhythm': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Seagrass': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Sverra': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Trillium': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Pulse': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 1': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 2': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 3': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 4': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 5': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 6': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 7': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 8': ['panel', 'frameBottom', 'frameTop'],
    'Laser Cut Kelly 9': ['panel', 'frameBottom', 'frameTop'],
    'Steel Mesh Allure': ['panel', 'frameBottom', 'frameTop'],
    'Steel Mesh Dazzle': ['panel', 'frameBottom', 'frameTop'],
    'Steel Mesh Metropolitan': ['panel', 'frameBottom', 'frameTop'],
    'Steel Mesh Horizon': ['panel', 'frameBottom', 'frameTop']
  };

  // (relates to syncObjsThatNeedToMatchThisObjColor)
  // obect relations of color/materail matching
  // based on productTypes and object names
  objsWhichColorsSyncedWithThisColor = [
    {
      'Laser Cut Agama': ['frameLeft', 'frameRight'],
      'Laser Cut Bound': ['frameLeft', 'frameRight'],
      'Laser Cut Cubist': ['frameLeft', 'frameRight'],
      'Laser Cut Pisces': ['frameLeft', 'frameRight'],
      'Laser Cut Rhythm': ['frameLeft', 'frameRight'],
      'Laser Cut Seagrass': ['frameLeft', 'frameRight'],
      'Laser Cut Sverra': ['frameLeft', 'frameRight'],
      'Laser Cut Trillium': ['frameLeft', 'frameRight'],
      'Laser Cut Pulse': ['frameLeft', 'frameRight'],
      'Steel Mesh Allure': ['frameLeft', 'frameRight'],
      'Steel Mesh Dazzle': ['frameLeft', 'frameRight'],
      'Steel Mesh Metropolitan': ['frameLeft', 'frameRight'],
      'Steel Mesh Horizon': ['frameLeft', 'frameRight'],
      tuneMaterial: 'metallicMaterial',
      color: 'Post'
    }
  ];

  public setSpaceForStairs(facsiaMount) {
    this.minimalSpaceForStairsOnSIde = 0;//facsiaMount ? 30 : 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/constants.service.ts